module.exports = __webpack_public_path__ + "static/media/whatsapp.41f1fc2e.svg";